import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSWR from 'swr';
import { OutpostAttempt } from '../../../../../../../typings/outpost';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { capitalizeFirstLetter } from '../../../../utils';
import { formatDate } from '../../../../utils/date';
import Badge from '../../../common/base/Badge';
import Chip from '../../../common/base/Chip';
import Divider from '../../../common/base/Divider';
import Icon from '../../../common/base/Icon';
import Text from '../../../common/base/Text';
import { Div } from '../../../common/helpers/StyledUtils';
import { MetadataGrid } from '../../../common/MetadataGrid';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { useDatePreferences } from '../../../hooks/useDatePreferences';
import { DestinationTypeIcon } from '../Destinations/DestinationTypeIcon';
import { getOutpostTenantLabel, useOutpostTenantsById } from '../utils/tenantDisplay';
const AttemptDetails: React.FC<{
  attempt: OutpostAttempt;
  embedded?: boolean;
  context?: 'outpost' | 'operator-events';
}> = t0 => {
  const $ = _c(101);
  const {
    attempt,
    embedded: t1,
    context: t2
  } = t0;
  const embedded = t1 === undefined ? false : t1;
  const context = t2 === undefined ? "outpost" : t2;
  const {
    timezone
  } = useDatePreferences();
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const t3 = embedded ? 1 : "120px 1fr";
  const t4 = embedded ? 0 : 3;
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = {
      columns: t3,
      gap: t4,
      gap_x: 6
    };
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const grid = t5;
  const destination_link = `/tenants/${attempt.tenant_id}/destinations/${attempt.destination_id}`;
  let t6;
  if ($[3] !== attempt.tenant_id) {
    t6 = [attempt.tenant_id];
    $[3] = attempt.tenant_id;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const {
    tenants_by_id
  } = useOutpostTenantsById(t6);
  let t7;
  if ($[5] !== attempt.destination) {
    t7 = attempt.destination ? APIMethodKeys.outpost.destinationTypes.get(attempt.destination.type) : null;
    $[5] = attempt.destination;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== HookdeckAPI.outpost.destinationTypes || $[8] !== attempt.destination?.type) {
    t8 = () => HookdeckAPI.outpost.destinationTypes.get(attempt.destination?.type || "");
    $[7] = HookdeckAPI.outpost.destinationTypes;
    $[8] = attempt.destination?.type;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const {
    data: destination_type
  } = useSWR(t7, t8);
  const t9 = embedded ? 1 : 2;
  const t10 = embedded ? 0 : 3;
  let t11;
  if ($[10] !== t10 || $[11] !== t9) {
    t11 = {
      columns: t9,
      gap: t10
    };
    $[10] = t10;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Text muted={true} ellipsis={true}>Status</Text>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = attempt.status === "success";
  const t14 = attempt.status === "failed";
  let t15;
  if ($[14] !== attempt.status) {
    t15 = capitalizeFirstLetter(attempt.status);
    $[14] = attempt.status;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t13 || $[17] !== t14 || $[18] !== t15) {
    t16 = <Badge subtle={true} success={t13} danger={t14}>{t15}</Badge>;
    $[16] = t13;
    $[17] = t14;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== embedded || $[21] !== grid || $[22] !== t16) {
    t17 = <MetadataGrid embedded={embedded} grid={grid}>{t12}{t16}</MetadataGrid>;
    $[20] = embedded;
    $[21] = grid;
    $[22] = t16;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== embedded) {
    t18 = embedded && <Divider />;
    $[24] = embedded;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Text muted={true} ellipsis={true}>Response code</Text>;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  const t20 = !attempt.code;
  const t21 = attempt.code ?? "\u2014";
  let t22;
  if ($[27] !== t20 || $[28] !== t21) {
    t22 = <Text mono={true} size="s" ellipsis={true} muted={t20}>{t21}</Text>;
    $[27] = t20;
    $[28] = t21;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  let t23;
  if ($[30] !== embedded || $[31] !== grid || $[32] !== t22) {
    t23 = <MetadataGrid embedded={embedded} grid={grid}>{t19}{t22}</MetadataGrid>;
    $[30] = embedded;
    $[31] = grid;
    $[32] = t22;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== embedded) {
    t24 = embedded && <Divider />;
    $[34] = embedded;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== attempt.event_id || $[37] !== context || $[38] !== embedded || $[39] !== grid) {
    t25 = context === "outpost" && <><MetadataGrid embedded={embedded} grid={grid}><Text muted={true} ellipsis={true}>Event</Text><Chip mono={true} outline={true} label={attempt.event_id} to={`/events/${attempt.event_id}`} /></MetadataGrid>{embedded && <Divider />}</>;
    $[36] = attempt.event_id;
    $[37] = context;
    $[38] = embedded;
    $[39] = grid;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] !== attempt.destination || $[42] !== attempt.destination_id || $[43] !== context || $[44] !== destination_link || $[45] !== destination_type || $[46] !== embedded || $[47] !== grid) {
    t26 = context === "outpost" && <><MetadataGrid embedded={embedded} grid={grid}><Text muted={true} ellipsis={true} style={{
          flexShrink: 0
        }}>Destination</Text>{attempt.destination ? <Chip outline={true} title={attempt.destination.target} label={<Div flex={{
          align: "center",
          gap: 1
        }}><DestinationTypeIcon type={attempt.destination.type} type_meta={destination_type} /><Text as="span" size="xs" semi={true} p={{
            x: 1
          }} ellipsis={true}>{attempt.destination.target}</Text></Div>} to={destination_link} /> : <Text muted={true} size="s" ellipsis={true}>{attempt.destination_id} (deleted)</Text>}</MetadataGrid>{embedded && <Divider />}</>;
    $[41] = attempt.destination;
    $[42] = attempt.destination_id;
    $[43] = context;
    $[44] = destination_link;
    $[45] = destination_type;
    $[46] = embedded;
    $[47] = grid;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== attempt.tenant_id || $[50] !== context || $[51] !== embedded || $[52] !== grid || $[53] !== tenants_by_id) {
    t27 = context === "outpost" && <><MetadataGrid embedded={embedded} grid={grid}><Text muted={true} ellipsis={true}>Tenant</Text><Chip outline={true} label={getOutpostTenantLabel(attempt.tenant_id, tenants_by_id[attempt.tenant_id])} to={`/tenants/${attempt.tenant_id}`} /></MetadataGrid>{embedded && <Divider />}</>;
    $[49] = attempt.tenant_id;
    $[50] = context;
    $[51] = embedded;
    $[52] = grid;
    $[53] = tenants_by_id;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Text muted={true} ellipsis={true}>Time</Text>;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== attempt.time || $[57] !== timezone) {
    t29 = formatDate(attempt.time, "MMM d HH:mm:ss", timezone).toUpperCase();
    $[56] = attempt.time;
    $[57] = timezone;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== t29) {
    t30 = <Text mono={true} ellipsis={true}>{t29}</Text>;
    $[59] = t29;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== embedded || $[62] !== grid || $[63] !== t30) {
    t31 = <MetadataGrid embedded={embedded} grid={grid}>{t28}{t30}</MetadataGrid>;
    $[61] = embedded;
    $[62] = grid;
    $[63] = t30;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  let t32;
  if ($[65] !== embedded) {
    t32 = embedded && <Divider />;
    $[65] = embedded;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Text muted={true} ellipsis={true}>Attempt number</Text>;
    $[67] = t33;
  } else {
    t33 = $[67];
  }
  let t34;
  if ($[68] !== attempt.attempt_number) {
    t34 = <Badge neutral={true}>{attempt.attempt_number}</Badge>;
    $[68] = attempt.attempt_number;
    $[69] = t34;
  } else {
    t34 = $[69];
  }
  let t35;
  if ($[70] !== embedded || $[71] !== grid || $[72] !== t34) {
    t35 = <MetadataGrid embedded={embedded} grid={grid}>{t33}{t34}</MetadataGrid>;
    $[70] = embedded;
    $[71] = grid;
    $[72] = t34;
    $[73] = t35;
  } else {
    t35 = $[73];
  }
  let t36;
  if ($[74] !== embedded) {
    t36 = embedded && <Divider />;
    $[74] = embedded;
    $[75] = t36;
  } else {
    t36 = $[75];
  }
  let t37;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <Text muted={true} ellipsis={true}>Manual retry</Text>;
    $[76] = t37;
  } else {
    t37 = $[76];
  }
  let t38;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = {
      gap: 2,
      align: "center"
    };
    $[77] = t38;
  } else {
    t38 = $[77];
  }
  const t39 = attempt.manual ? "Yes" : "No";
  let t40;
  if ($[78] !== attempt.manual) {
    t40 = attempt.manual && <Icon icon="manual" neutral={true} small={true} />;
    $[78] = attempt.manual;
    $[79] = t40;
  } else {
    t40 = $[79];
  }
  let t41;
  if ($[80] !== t39 || $[81] !== t40) {
    t41 = <Text mono={true} size="s" ellipsis={true} flex={t38}>{t39}{t40}</Text>;
    $[80] = t39;
    $[81] = t40;
    $[82] = t41;
  } else {
    t41 = $[82];
  }
  let t42;
  if ($[83] !== embedded || $[84] !== grid || $[85] !== t41) {
    t42 = <MetadataGrid embedded={embedded} grid={grid}>{t37}{t41}</MetadataGrid>;
    $[83] = embedded;
    $[84] = grid;
    $[85] = t41;
    $[86] = t42;
  } else {
    t42 = $[86];
  }
  let t43;
  if ($[87] !== t11 || $[88] !== t17 || $[89] !== t18 || $[90] !== t23 || $[91] !== t24 || $[92] !== t25 || $[93] !== t26 || $[94] !== t27 || $[95] !== t31 || $[96] !== t32 || $[97] !== t35 || $[98] !== t36 || $[99] !== t42) {
    t43 = <Div grid={t11}>{t17}{t18}{t23}{t24}{t25}{t26}{t27}{t31}{t32}{t35}{t36}{t42}</Div>;
    $[87] = t11;
    $[88] = t17;
    $[89] = t18;
    $[90] = t23;
    $[91] = t24;
    $[92] = t25;
    $[93] = t26;
    $[94] = t27;
    $[95] = t31;
    $[96] = t32;
    $[97] = t35;
    $[98] = t36;
    $[99] = t42;
    $[100] = t43;
  } else {
    t43 = $[100];
  }
  return t43;
};
export default AttemptDetails;